import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styles from './validatedSelectModalRadio.module.scss'
import { HiOutlineChevronDown } from 'react-icons/hi'
import { AiOutlineClose } from 'react-icons/ai'
import ValidatedInput from '../ValidatedInput'
import Modal from '../Modal'
import ValidatedRadioInput from '../ValidatedInput/ValidatedRadioInput'

const Option = ({ data, onClick, selected }) => {
  const { label, value } = data
  return (
    <ValidatedRadioInput
      onClick={onClick}
      selected={selected}
      label={label}
      value={value}
    />
  )
}

const ValidatedSelectModalRadio = React.forwardRef(
  (
    {
      message,
      rules,
      header,
      name,
      error,
      showErrorAsNeutral,
      successIcon,
      errorIcon,
      onSelect,
      options,
      placeholder,
      ...restProps
    },
    ref
  ) => {
    const [visible, setVisible] = useState(false)
    const [value, setValue] = useState(placeholder)
    const [label, setLabel] = useState(placeholder)

    const handleSelect = (option) => () => {
      setVisible(false)
      setValue(option.value)
      setLabel(option.label)
      onSelect(option.value)
    }

    const vRules = rules || []
    return (
      <div className={styles.container}>
        <div className={styles.selector} onClick={() => setVisible(true)}>
          <ValidatedInput
            rules={vRules}
            type='text'
            ref={ref}
            name={name}
            defaultVisible
            header={!error && header}
            error={error}
            value={label}
            readOnly
            showErrorAsNeutral={showErrorAsNeutral}
            externalValue={value}
            selector
            {...restProps}
          />
          <div className={styles.chevron}>
            <span>
              <HiOutlineChevronDown />
            </span>
          </div>
        </div>
        <Modal isOpen={visible} classNames={[styles.modal]}>
          <div className={styles.modal__content}>
            <AiOutlineClose
              className={styles.close__icon}
              onClick={() => setVisible(false)}
            />
            <div className={styles.options__content}>
              <section className={styles.options__data}>
                {options.map((e) => (
                  <Option
                    key={e.id}
                    onClick={handleSelect(e)}
                    data={e}
                    selected={value === e.value}
                  />
                ))}
              </section>
            </div>
          </div>
        </Modal>
      </div>
    )
  }
)

ValidatedSelectModalRadio.propTypes = {
  placeholder: PropTypes.string,
  onSelect: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      value: PropTypes.string,
      label: PropTypes.string
    })
  )
}

ValidatedSelectModalRadio.defaultProps = {
  options: [],
  placeholder: '',
  onSelect: () => -1
}

export default ValidatedSelectModalRadio
